export default "__VITE_ASSET__086f09f7__"